import { COOKIE_SID } from "@/constants/normal";
import cookieStorage from "@/stores/utils/cookieStorage";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export async function initFingerprint() {
  const storedVisitorId = localStorage.getItem("visitorId");

  if (storedVisitorId) {
    cookieStorage.setItem(COOKIE_SID, storedVisitorId);
  } else {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();

    localStorage.setItem("visitorId", visitorId);
    cookieStorage.setItem(COOKIE_SID, visitorId);
  }
}
